import { gql } from "@apollo/client";

export const TrialCalendarQuery = gql`
  query getAllTrialCalendar(
    $role: String
    $city: String
    $state: String
    $level: [String!]
    $search: String
    $pageNumber: Int!
    $pageSize: Int!
    $approvalStatus: String
    $trialStatus: String
    $fromDate: DateTime
    $toDate: DateTime
    $timeInterval: String
    $trialResult: Boolean
    $excludeShared: Boolean
  ) {
    getAllTrialCalendar(
      pageNumber: $pageNumber
      pageSize: $pageSize
      city: $city
      state: $state
      level: $level
      search: $search
      role: $role
      approvalStatus: $approvalStatus
      trialStatus: $trialStatus
      fromDate: $fromDate
      toDate: $toDate
      timeInterval: $timeInterval
      trialResult: $trialResult
      excludeShared: $excludeShared
    ) {
      data {
        id
        authId
        noOfEntries
        level
        levelMap
        judgeName
        host {
          id
          hostName
          contactAddress
          city
          trialSecretaryName
          state
          trialSecretaryEmail
          zip
          paypalEmail
          paypalPaymentLink
        }
        trial {
          id
          trialName
          trialLocationName
          trialLocationAddress
          city
          state
          zip
          timezone
          openDate
          closeDate
          cutoffDate
          trialDate
          trialFile
          description
          notes
          status
          noOfJudge
          trialFees
          trialImages
          judgeAuthId
          status
          approvalStatus
          maxEntries
        }
        search {
          id
          level
          search
          searchName
          entryFee
          element
        }
      }
      pageNumber
      pageSize
      totalDocs
      totalPages
      totalCount
    }
  }
`;

export const DocsSignupMutation = gql`
  mutation createDogTrial($data: [CreateDogTrialInput!]!) {
    createDogTrial(data: $data) {
      dog
      division
      authId
      elements
      searchId
    }
  }
`;

export const generateEntries = gql`
  query generateEntriesPdf($trialCalendarId: Int!) {
    generateEntriesPdf(trialCalendarId: $trialCalendarId) {
      message
      url
    }
  }
`;

export const getSearchByTrialCalendarIdQuery = gql`
  query GetSearchByTrialCalendarId($trialCalendarId: Int!) {
    getSearchByTrialCalendarId(trialCalendarId: $trialCalendarId) {
      id
      search
      searchName
      element
    }
  }
`;
export const UPDATE_TRIAL_APPROVAL_MUTATION = gql`
  mutation UpdateTrialApproval($id: Int!, $approvalStatus: String!) {
    updateTrialApprovalStatus(
      id: $id
      data: { approvalStatus: $approvalStatus }
    ) {
      message
    }
  }
`;

export const deleteTrialCalendarByAdminMutation = gql`
  mutation DeleteTrialCalendarByAdmin($trialCalendarId: Int!) {
    deleteTrialCalendarByAdmin(trialCalendarId: $trialCalendarId) {
      message
    }
  }
`;

export const updateHostOwnTrialCalendarMutation = gql`
  mutation UpdateHostOwnTrialCalendar(
    $trialCalendarId: Int!
    $data: UpdateTrialCalendarInput!
  ) {
    updateHostOwnTrialCalendar(trialCalendarId: $trialCalendarId, data: $data) {
      id
      authId
      host {
        id
        hostName
        contactAddress
        city
        trialSecretaryName
        state
        trialSecretaryEmail
        zip
        phoneNumber
        paypalEmail
        paypalPaymentLink
      }
      trail {
        id
        trialName
        trialLocationName
        trialLocationAddress
        city
        state
        zip
        timezone
        trialDate
        openDate
        closeDate
        cutoffDate
        trialFile
        description
        notes
        noOfJudge
        judgeAuthId
        trialFees
        maxEntries
        trialImages
        status
        approvalStatus
      }
      searches {
        id
        level
        element
        search
        searchName
        entryFee
      }
    }
  }
`;

export const updateTrialCalendarByAdminMutation = gql`
  mutation UpdateTrialCalendarByAdmin(
    $trialCalendarId: Int!
    $data: UpdateTrialCalendarInput!
  ) {
    updateTrialCalendarByAdmin(trialCalendarId: $trialCalendarId, data: $data) {
      id
      authId
      host {
        id
        hostName
        contactAddress
        city
        trialSecretaryName
        state
        trialSecretaryEmail
        zip
        phoneNumber
        paypalEmail
        paypalPaymentLink
      }
      trail {
        id
        trialName
        trialLocationName
        trialLocationAddress
        city
        state
        zip
        timezone
        trialDate
        openDate
        closeDate
        cutoffDate
        trialFile
        description
        notes
        noOfJudge
        judgeAuthId
        trialFees
        maxEntries
        trialImages
        status
        approvalStatus
      }
      searches {
        id
        level
        element
        search
        searchName
        entryFee
      }
    }
  }
`;

export const UPDATE_TRIAL_SHARING = gql`
  mutation UpdateTrialSharing(
    $trialCalendarId: Int!
    $helperEmail: String!
    $action: String!
  ) {
    updateTrialSharing(
      trialCalendarId: $trialCalendarId
      helperEmail: $helperEmail
      action: $action
    ) {
      message
      user {
        name
        email
        authId
      }
    }
  }
`;
